module.exports = __webpack_public_path__ + "img/sx.73a3a17.svg";